import React from 'react';
import { CheckboxContainer, HiddenCheckbox, StyledCheckboxBox } from './styles';

interface StyledCheckboxProps {
  id?: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
}

const StyledCheckbox: React.FC<StyledCheckboxProps> = ({
  id,
  checked,
  onChange,
  onClick,
  disabled = false
}) => {
  return (
    <CheckboxContainer onClick={onClick}>
      <HiddenCheckbox
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <StyledCheckboxBox checked={checked}>
        <svg viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </StyledCheckboxBox>
    </CheckboxContainer>
  );
};

export default StyledCheckbox;

